import { FC } from 'react'

type IconTriangleRightProps = {
  className?: string
}

export const IconTriangleRight: FC<IconTriangleRightProps> = ({
  className,
}) => {
  return (
    <svg
      className={className}
      fill="none"
      height="24"
      viewBox="0 0 12 24"
      width="12"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3732 12.6785C11.7271 12.2954 11.7271 11.7046 11.3732 11.3214L1.73455 0.887327C1.11698 0.218788 0 0.655748 0 1.56588L0 22.4341C0 23.3443 1.11698 23.7812 1.73455 23.1127L11.3732 12.6785Z"
        fill="#999999"
      />
    </svg>
  )
}
